import { Component } from '@angular/core';

@Component({
    templateUrl: './app-form.component.html',
    standalone: false
})
export class AppFormComponent {
}
